import { OpeningStatusV2Service } from 'api-clients/monolith';

import type { ListingStatus } from '@/utils/posting-eligibility';

export function enableOpeningSourcing({
  openingId,
  expectedListingStatus,
}: {
  openingId: string;
  expectedListingStatus: ListingStatus;
}) {
  return OpeningStatusV2Service.patchApiSelfServeV2OpeningsListingStatus(
    openingId,
    {
      listing_status: 'public',
      expected_listing_status: expectedListingStatus,
    },
  );
}
